<template>
    <my-dialog :title="title" :visible.sync="showDetailVisible" @close="closeDialog()" :close-on-click-modal="false"
        :modal="false" width="80%">
        <div class="main_bg">
            <div class="item_info border_Warningcolor">
                <el-descriptions :column="3" :border="true" title="申购单信息" :label-width="120">
                    <el-descriptions-item label="所属门店">
                        <span class="descriptions-item-value">{{ subscriptionInfo.storeName }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="申购人">
                        <span class="descriptions-item-value">{{ subscriptionInfo.creator }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="申购时间">
                        <span class="descriptions-item-value">{{ subscriptionInfo.createTime }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="申购单编号">{{ subscriptionInfo.code }}</el-descriptions-item>
                    <el-descriptions-item label="申购状态">
                        <span class="descriptions-item-value">{{ subscriptionInfo.stateStr }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="快递单号">
                        <span class="descriptions-item-value">{{ subscriptionInfo.kdNo }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="备注">{{ subscriptionInfo.remark }}</el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="item_info border_Green">
                <div class="item_title">
                    <div class="title">商品信息</div>
                    <div class="btnDiv">
                    </div>
                </div>
                <el-table :data="productTableData" style="width: 100%" border
                    :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                    <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
                    <el-table-column prop="typeName" label="类型" width="140"></el-table-column>
                    <el-table-column prop="productName" label="系列" width="160"> </el-table-column>
                    <el-table-column prop="specification" label="商品名称" width="160"></el-table-column>
                    <el-table-column prop="productBrand" label="商品品牌" width="160"></el-table-column>
                    <el-table-column prop="quantity" label="数量" width="70"></el-table-column>
                    <el-table-column prop="unit" label="单位" width="70"></el-table-column>
                    <el-table-column prop="costMoney" label="成本(元)" width="90"></el-table-column>
                    <el-table-column prop="shippingCost" label="运费(元)" width="90"></el-table-column>
                    <el-table-column prop="totalMoney" label="小计(元)" width="90">
                        <template slot-scope="scope">
                            ￥{{ scope.row.costMoney * scope.row.quantity + scope.row.shippingCost }}元
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="productDate" label="生产日期" width="110"></el-table-column>
                    <el-table-column prop="expireDate" label="过期日期" width="110"></el-table-column>
                    <el-table-column prop="price" label="售价(元)" width="140"></el-table-column> -->
                    <el-table-column prop="supplyName" label="付款对象" width="200"></el-table-column>
                    <el-table-column prop="remark" label="备注" width="250"></el-table-column>
                    <el-table-column prop="kdNo" label="快递单号" width="220"></el-table-column>
                </el-table>
            </div>
            <div class="item_info border_Green">
                <div class="item_title">
                    <div class="title">操作日志</div>
                    <div class="btnDiv">
                    </div>
                </div>
                <!-- 操作日志 -->
                <operationLog ref="operationLog"></operationLog>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" icon="el-icon-close" @click="closeDialog()">取消</el-button>
            <el-button v-if="subscriptionInfo.state == 4 && this.$checkBtnPermission('/storeSubscription/index', 'pay')"
                size="small" icon="el-icon-finished" :loading="loading" type="warning"
                @click="handlePayClick">支付申购单</el-button>
        </div>
    </my-dialog>
</template>

<script>
import {
    GetStoreSubscriptionDetail,
    PayStoreSubScription,
} from "@/api/productApi.js";
import operationLog from "@/views/system/operationLog/businessOperationLog.vue";
export default {
    props: {
        storeList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showDetailVisible: false,
            loading: false,
            title: "支付申购单",
            subscriptionInfo: {},
            productTableData: [],
        };
    },
    created() { },
    mounted() { },
    components: {
        operationLog,
    },
    methods: {
        // 展示详情
        showPaySubscriptionDetail(keyId) {
            this.subscriptionInfo = {};
            GetStoreSubscriptionDetail({
                keyId: keyId
            }).then(res => {
                if (res.code == 1) {
                    this.subscriptionInfo = res.data;
                    this.productTableData = [];
                    if (res.data.dtls != null && res.data.dtls.length > 0) {
                        var index = 1;
                        res.data.dtls.forEach((item) => {
                            this.productTableData.push({
                                rowNumber: index++,
                                productKeyId: item.productTypeInfo.keyId,
                                typeName: item.productTypeInfo.typeName,
                                productName: item.productTypeInfo.productName,
                                specification: item.productTypeInfo.specification,
                                quantity: item.quantity,
                                unit: item.productTypeInfo.unit,
                                remark: item.remark,
                                costMoney: item.costMoney,
                                productDate: item.productDate,
                                expireDate: item.expireDate,
                                keyId: item.keyId,
                                price: item.price,
                                shippingCost: item.shippingCost,
                                supplyName: item.supplyName,
                                productBrand: item.productBrand,
                                kdNo: item.kdNo,
                            });
                        });
                    }
                    this.title = "支付申购单";
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.$nextTick(() => {
                // 展示操作日志
                this.$refs.operationLog.showOperationLog(keyId);
            });
            this.showDetailVisible = true;
        },
        // 关闭详情弹出框
        closeDialog() {
            this.subscriptionInfo = {};
            this.showDetailVisible = false;
        },
        // 支付申购单
        handlePayClick() {
            if (this.subscriptionInfo.state != 4) {
                this.$message({
                    type: 'warning',
                    message: '申购单状态不是【待财务支付】状态，不能支付'
                });
                return;
            }
            this.$confirm('确认支付吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.productTableData.length == 0) {
                    this.$message({
                        type: 'warning',
                        message: '请添加申购商品'
                    });
                    return;
                };

                this.loading = true;
                var params = {
                    keyId: this.subscriptionInfo.keyId,
                }
                PayStoreSubScription(params).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '支付成功'
                        });
                        this.closeDialog();
                        this.$parent.getListData();
                    } else {
                        this.loading = false;
                        this.$message.error(res.msg);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
    },
};
</script>
<style scoped>
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.formDiv {
    border: 1px solid #e9e7e7;
    padding: 10px;
    border-radius: 5px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;
}

.item_title .title {
    display: inline-block;
    unicode-bidi: isolate;
}

.item_title .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
}
</style>